import { render } from "./RecipeBook.vue?vue&type=template&id=79438ca0&scoped=true"
import script from "./RecipeBook.vue?vue&type=script&lang=js"
export * from "./RecipeBook.vue?vue&type=script&lang=js"

import "./recipebook.css?vue&type=style&index=0&id=79438ca0&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79438ca0"]])

export default __exports__